import * as React from 'react';
import { useState } from 'react';
import styled from '@emotion/styled';
import Button from 'components/common/Button';
import { getUtcUsFormatDate } from 'modules/utils/time';
import EditDateModal from 'components/backorder/modal/EditDateModal';

interface Props {
  type: 'start' | 'end';
  subscriptionId: number;
  targetDate: string | null;
  canEdit: boolean;
}
const EditDateButton = ({
  subscriptionId,
  targetDate,
  type,
  canEdit,
}: Props): React.ReactElement => {
  const [editDateModalVisibility, setEditDateModalVisibility] = useState<boolean>(false);

  const openEditDateModal = () => {
    setEditDateModalVisibility(true);
  };

  const closetEditEndDateModal = () => {
    setEditDateModalVisibility(false);
  };
  return (
    <>
      <ButtonWrapper>
        <DateWrapper>{targetDate ? getUtcUsFormatDate(targetDate) : '-'}</DateWrapper>
        <Button
          variant="contained"
          size="small"
          color="primary"
          onClick={openEditDateModal}
          disabled={!canEdit}
        >
          Edit
        </Button>
      </ButtonWrapper>
      {editDateModalVisibility && (
        <EditDateModal
          type={type}
          subscriptionId={subscriptionId}
          targetDate={targetDate}
          onClose={closetEditEndDateModal}
        />
      )}
    </>
  );
};

export default EditDateButton;

const DateWrapper = styled.div`
  height: fit-content;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;
